import type { FC } from 'react';

import { startCase } from 'lodash-es';

import type { JobsJobElasticSchemaWithId } from '@iconik-io/iconik-api/src/services/jobs';

import styles from './job_type.module.css';

type Props = {
  job: JobsJobElasticSchemaWithId;
};

const JobType: FC<Props> = ({ job }) => (
  <div className={styles.root}>
    {job.custom_type ?? startCase(job.type.toLowerCase())}{' '}
    {job.type === 'SCAN' ? <span>({job.progress_processed} files)</span> : null}
  </div>
);

export default JobType;
